<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Movement Type",
        value: "movementType",
        sortable: false
      },
      {
        text: "From",
        value: "from",
        sortable: false
      },
      {
        text: "To",
        value: "to",
        sortable: false
      },
      {
        text: "Movement Type Details",
        value: "movementTypeDetails",
        sortable: false
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: false
      },
      {
        text: "Effect Date",
        value: "effectDate",
        sortable: false
      },
      {
        text: "Payroll Location ID From",
        value: "locIDFrom",
        sortable: false
      },
      {
        text: "Payroll Location ID To",
        value: "locIDTo",
        sortable: false
      },
      {
        text: "Department From",
        value: "depFrom",
        sortable: false
      },
      {
        text: "Department To",
        value: "depTo",
        sortable: false
      },
      {
        text: "Division From",
        value: "divFrom",
        sortable: false
      },
      {
        text: "Division To",
        value: "divTo",
        sortable: false
      },
      {
        text: "Branch From",
        value: "branchFrom",
        sortable: false
      },
      {
        text: "Branch To",
        value: "branchTo",
        sortable: false
      },
      {
        text: "Section From",
        value: "sectionFrom",
        sortable: false
      },
      {
        text: "Section To",
        value: "sectionTo",
        sortable: false
      },
      {
        text: "Designation From",
        value: "desFrom",
        sortable: false
      },
      {
        text: "Designation To",
        value: "desTo",
        sortable: false
      },
      {
        text: "Unit From",
        value: "unitFrom",
        sortable: false
      },
      {
        text: "Unit To",
        value: "unitTo",
        sortable: false
      },
      {
        text: "Area From",
        value: "areaFrom",
        sortable: false
      },
      {
        text: "Area To",
        value: "areaTo",
        sortable: false
      },
      {
        text: "Location From",
        value: "locFrom",
        sortable: false
      },
      {
        text: "Location To",
        value: "locTo",
        sortable: false
      },
      {
        text: "Base Site From",
        value: "baseSiteFrom",
        sortable: false
      },
      {
        text: "Base Site To",
        value: "baseSiteTo",
        sortable: false
      },
      {
        text: "Employee Status From",
        value: "empStatFrom",
        sortable: false
      },
      {
        text: "Employee Status To",
        value: "empStatTo",
        sortable: false
      },
      {
        text: "Date Applied",
        value: "dateApplied",
        sortable: false
      },
      {
        text: "Date Hired",
        value: "dateHired",
        sortable: false
      },
      {
        text: "Date Regularized",
        value: "dateRegularized",
        sortable: false
      },
      {
        text: "Probe Start",
        value: "probeStart",
        sortable: false
      },
      {
        text: "Probe End",
        value: "probeEnd",
        sortable: false
      },
      {
        text: "Union Member",
        value: "unionMember",
        sortable: false
      },
      {
        text: "Agency",
        value: "agency",
        sortable: false
      },
      {
        text: "Pay Code",
        value: "payCode",
        sortable: false
      },
      {
        text: "Rate Code",
        value: "rateCode",
        sortable: false
      },
      {
        text: "End Contact",
        value: "endContract",
        sortable: false
      },
      {
        text: "Starting Salary",
        value: "startingSalary",
        sortable: false
      },
      {
        text: "Designation Desired",
        value: "desDesired",
        sortable: false
      },
      {
        text: "Tax Flag",
        value: "taxFlag",
        sortable: false
      },
      {
        text: "SSS Flag",
        value: "sssFlag",
        sortable: false
      },
      {
        text: "PagFlag",
        value: "pagFlag",
        sortable: false
      },
      {
        text: "PhilFlag",
        value: "philFlag",
        sortable: false
      },
      {
        text: "Bonus13thFlag",
        value: "bonus13thFlag",
        sortable: false
      },
      {
        text: "Inactive",
        value: "inactive",
        sortable: false
      },
      {
        text: "End Contract To",
        value: "endContractTo",
        sortable: false
      },
      {
        text: "Probe Start To",
        value: "probeStartTo",
        sortable: false
      },
      {
        text: "Date Resigned To",
        value: "dateResignedTo",
        sortable: false
      },
      {
        text: "Date Hired To",
        value: "dateHiredTo",
        sortable: false
      },
      {
        text: "Tax Rate Code",
        value: "taxRateCode",
        sortable: false
      },
      {
        text: "Group To",
        value: "groupTo",
        sortable: false
      },
      {
        text: "Project From",
        value: "projectFrom",
        sortable: false
      },
      {
        text: "Project From",
        value: "projectTo",
        sortable: false
      },
      {
        text: "Tax Code From",
        value: "taxCodeFrom",
        sortable: false
      },
      {
        text: "Tax Code To",
        value: "taxCodeTo",
        sortable: false
      },
      {
        text: "Employee Category From",
        value: "empCatFrom",
        sortable: false
      },
      {
        text: "Employee Category To",
        value: "empCatTo",
        sortable: false
      },
      {
        text: "Rank From",
        value: "rankFrom",
        sortable: false
      },
      {
        text: "Rank To",
        value: "rankTo",
        sortable: false
      },
      {
        text: "Salary Classification From",
        value: "salaryClassFrom",
        sortable: false
      },
      {
        text: "Salary Classification To",
        value: "salaryClassTo",
        sortable: false
      },
      {
        text: "Job Level From",
        value: "jobLevelFrom",
        sortable: false
      },
      {
        text: "Job Level To",
        value: "jobLevelTo",
        sortable: false
      },
      {
        text: "TKS Group From",
        value: "tksGroupFrom",
        sortable: false
      },
      {
        text: "TKS Group To",
        value: "tksGroupTo",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return item.property == "ALL" && item.index == index;
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>